

<div class="dashboard">

  <div class="dashboard-header">
    <div>
      <h1>xPetros Water Quality Analytics</h1>
      <p>Operations Dashboard</p>
    </div>
  </div>
  
  <!-- LTBV Copilot - Uncomment all LTBV to reinstall Copilot-->
  <!-- <div>
    <button class="copilot-button"  (click)="showCopilot = !showCopilot"> 🤖 </button>

    <div *ngIf="showCopilot" class="copilot-popup">
      <app-copilot-chat></app-copilot-chat>
    </div>
  </div> -->

  <!-- Summary Cards -->
  <div class="summary-grid">
    <div class="summary-card">
      <div class="value">{{dashboardDto.openJobs.length}}</div>
      <div class="label">Open Jobs</div>
    </div>
    <div class="summary-card">
      <div class="value">{{dashboardDto.closedJobs.length}}</div>
      <div class="label">Closed Jobs on the last 4 months</div>
    </div>
    <div class="summary-card">
      <div class="value">{{dashboardDto.crewsWithOpenJobs.length}}</div>
      <div class="label">Active Crews</div>
    </div>
    <div class="summary-card">
      <div class="value">{{dashboardDto.customersWithOpenJobs.length}}</div>
      <div class="label">Customers w/Open Jobs</div>
    </div>

  </div>

  <!-- Main Grid -->
  <div class="dashboard-grid">  

    <!-- Open Jobs -->
    <div class="panel">
      <h3>Open Jobs</h3>
      <div class="list-header">
        <span>Job Name</span>
        <span>Started On</span>
      </div>
      <div class="panel-content">
        <div class="list-item" *ngFor="let job of dashboardDto.openJobs">
          <span>
            <a (click)="goToList(job, 'WA')" 
            [ngStyle]="{ color: job.shouldBeClosed ? 'red' : '#0d6efd' }"
            [matTooltip]="job.shouldBeClosed? 'Crew ' + job.crewDto.name + ' is already assigned to another Job. Consider closing this job.' : null"
            >{{ job.jobName }} 
          </a>
          </span>
          <span>{{ job.startDate | date:'MMMM d, yyyy' }}</span>
        </div>
      </div>

      <!-- <a routerLink="/projects">View All Jobs</a> -->
    </div>

    <!-- Recent Closed Jobs -->
    <div class="panel">
      <h3>Closed Jobs (Last 4 Months)</h3>
      <div class="list-header">
        <span>Job Name</span>
        <span>Closed On</span>
      </div>
      <div class="panel-content">
        <div class="list-item" *ngFor="let job of dashboardDto.closedJobs">
          <span><a (click)="goToList(job, 'WA')" class="link-primary">{{ job.jobName }} </a></span>
          <span>{{ job.endDate | date:'MMMM d, yyyy' }}</span>
        </div>
      </div>
    </div>

    <!-- Crews -->
    <div class="panel">
      <h3>Active Crews</h3>
      <div class="list-header">
        <span>Crew Name</span>
        <span>Location</span>
      </div>      
        <div class="panel-content">
        <div class="list-item" *ngFor="let crew of dashboardDto.crewsWithOpenJobs">
          <!-- <span>{{ crew.name }}</span> -->
          <span>
            <a routerLink="/projects/" [queryParams]="{crewId: crew.id, status: 10}" style="text-decoration: none;">{{ crew.name }}</a>
          </span>
          <span>{{ getCrewLocation(crew) }}</span>
        </div>
      </div>
    </div>

    <!-- Customers -->
    <div class="panel">
      <h3>Active Customers</h3>
      <div class="list-header">
        <span>Customer Name</span>
        <span>Current Jobs</span>
      </div>  
        <div class="panel-content">
        <div class="list-item" *ngFor="let customer of dashboardDto.customersWithOpenJobs">
          <span>
              <a routerLink="/projects/customer" [queryParams]="{customerId: customer.id, status: 10}" style="text-decoration: none;">{{ customer.name }}</a>
          </span>
          <span>{{getCustomerOpenJobs(customer)}} Jobs</span>
        </div>
      </div>
    </div>

    <!-- Your Assignments -->
    <div class="panel">
      <h3>My Assignments</h3>
      <div class="list-header">
        <span>Job Name</span>
        <span>Log Type</span>
      </div>  
        <div class="panel-content">
        <div class="list-item" *ngFor="let job of dashboardDto.assignedJobs">
          <span>
              <a *ngIf="job.logType === 'WA'" routerLink="/logwas" [queryParams]="{projectId: job.id }" style="text-decoration: none;">{{ job.jobName }}</a>
              <a *ngIf="job.logType === 'ATP'" routerLink="/logatps" [queryParams]="{projectId: job.id }" style="text-decoration: none;">{{ job.jobName }}</a>
              <a *ngIf="job.logType === 'BQ'" routerLink="/logbqs" [queryParams]="{projectId: job.id }" style="text-decoration: none;">{{ job.jobName }}</a>
          </span>
          <span>{{ job.logType }}</span>
        </div>
      </div>
    </div>

  </div>

  <!-- Quick Actions -->
  <div class="panel quick-actions">
    <h3>Quick Actions</h3>
    <div class="actions-grid">
      <button [routerLink]="['/projects']"> Jobs </button>
        <button [routerLink]="['/postjob']">Post-Jobs</button>
        <button [routerLink]="['/summarypage']">Water Summary</button>
        <button [routerLink]="['/comparationpage']">Water Comparison</button>
    </div>

  </div>

</div>



